import { render, staticRenderFns } from "./CarouselModal.vue?vue&type=template&id=7fe1a261&scoped=true&"
import script from "./CarouselModal.vue?vue&type=script&lang=js&"
export * from "./CarouselModal.vue?vue&type=script&lang=js&"
import style0 from "./CarouselModal.vue?vue&type=style&index=0&id=7fe1a261&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1a261",
  null
  
)

export default component.exports